export const CREATE_BUILDING = 'CREATE_BUILDING'
export const UPDATE_BUILDING = 'UPDATE_BUILDING'
export const SET_USER = 'SET_USER'
export const RESET_USER = 'RESET_USER'
export const SET_QUICK_START_STATE = 'SET_QUICK_START_STATE'
export const RESET_QUICK_START_STATE = 'RESET_QUICK_START_STATE'
export const SET_PROFILE_OBJECT = 'SET_PROFILE_OBJECT'
export const SET_PROFILE_OBJECT_REMOVE_TENANT =
  'SET_PROFILE_OBJECT_REMOVE_TENANT'
export const SET_PROFILE_OBJECT_UPDATE_APARTMENT_OWNER =
  'SET_PROFILE_OBJECT_REMOVE_TENANT'
export const SET_PROFILE_OBJECT_UPDATE_TENANT =
  'SET_PROFILE_OBJECT_UPDATE_TENANT'
export const SET_PROFILE_OBJECT_UPDATE_LEASES =
  'SET_PROFILE_OBJECT_UPDATE_LEASES'
export const SET_APARTMENT_MODAL = 'SET_APARTMENT_MODAL'
export const SET_APARTMENT_MODAL_REMOVE_TENANT =
  'SET_APARTMENT_MODAL_REMOVE_TENANT'
export const SET_APARTMENT_MODAL_UPDATE_APARTMENT_OWNER =
  'SET_APARTMENT_MODAL_UPDATE_APARTMENT_OWNER'
export const SET_APARTMENT_MODAL_UPDATE_TENANT =
  'SET_APARTMENT_MODAL_UPDATE_TENANT'
export const SET_APARTMENT_MODAL_UPDATE_LEASES =
  'SET_APARTMENT_MODAL_UPDATE_LEASES'
export const SET_ANNOUNCEMENT_STATE = 'SET_ANNOUNCEMENT_STATE'
export const SET_CONTACT_MODAL_STATE = 'SET_CONTACT_MODAL_STATE'
export const SET_CONFIRMATION_MODAL_STATE =
  'SET_CONFIRMATION_MODAL_STATE'
export const SET_LEASE_MODAL_STATE = 'SET_LEASE_MODAL_STATE'
export const SET_AUTH_APPDATA_STATE = 'SET_AUTH_APPDATA_STATE'
export const ADD_MOVEOUT_CHECKLIST_ITEM = 'ADD_MOVEOUT_CHECKLIST_ITEM'
export const ADD_EMAIL_CADENCE_ITEM = 'ADD_EMAIL_CADENCE_ITEM'
export const UPDATE_EMAIL_SUBJECT_LINE = 'UPDATE_EMAIL_SUBJECT_LINE'
export const UPDATE_EMAIL_INTRODUCTION = 'UPDATE_EMAIL_INTRODUCTION'
export const UPDATE_BUILDING_ID = 'UPDATE_BUILDING_ID'
export const FETCH_TEMPLATES = 'FETCH_TEMPLATES'
export const SET_TEMPLATE_OBJECT = 'SET_TEMPLATE_OBJECT'
export const CREATE_TEMPLATE_OBJECT = 'CREATE_TEMPLATE_OBJECT'
export const UPDATE_TEMPLATE_OBJECT = 'UPDATE_TEMPLATE_OBJECT'
export const SET_PROFILE_OBJECT_ADD_LEASES =
  'SET_PROFILE_OBJECT_ADD_LEASES'
export const FETCH_TENANT_CONTACTS = 'FETCH_TENANT_CONTACTS'
export const SET_TENANT_PAGINATION = 'SET_TENANT_PAGINATION'
export const SET_OWNER_PAGINATION = 'SET_OWNER_PAGINATION'
export const FETCH_OWNER_CONTACTS = 'FETCH_OWNER_CONTACTS'
export const SET_CONTACT_COMP_MODAL_STATE =
  'SET_CONTACT_COMP_MODAL_STATE'
export const UPDATE_TENANT_CONTACT = 'UPDATE_TENANT_CONTACT'
export const UPDATE_OWNER_CONTACT = 'UPDATE_OWNER_CONTACT'
export const FETCH_ALL_TENANT_CONTACTS = 'FETCH_ALL_TENANT_CONTACTS'
export const SET_LOADER = 'SET_LOADER'
export const SET_NEW_RELEASE = 'SET_NEW_RELEASE'
export const SET_NEW_RELEASE_SUCCESS = 'SET_NEW_RELEASE_SUCCESS'
export const RESET = 'RESET'

// Thread Actions
export const NEW_PUSHER_MESSAGE = 'NEW_PUSHER_MESSAGE'
export const SET_USER_UNREAD_MESSAGES = 'SET_USER_UNREAD_MESSAGES'
export const SET_ERROR_SENDING_MESSAGE_BOOLEAN =
  'SET_ERROR_SENDING_MESSAGE_BOOLEAN'
export const SET_NEW_THREAD_MODAL_VISIBILITY =
  'SET_NEW_THREAD_MODAL_VISIBILITY'
export const SET_THREAD_USERS_MODAL_VISIBILITY =
  'SET_THREAD_USERS_MODAL_VISIBILITY'
export const UPDATE_THREAD_LIST = 'UPDATE_THREAD_LIST'
export const SET_THREAD_LIST_UPDATED = 'SET_THREAD_LIST_UPDATED'
export const SET_UNREAD_CONSTRAINTS = 'SET_UNREAD_CONSTRAINTS'
export const LOADING_UNREAD_COUNTS = 'LOADING_UNREAD_COUNTS'

// Tracked Actions
export const TRACKED_ACTIONS = {
  CREATE_BUILDING,
  SET_USER,
  RESET_USER,
  SET_APARTMENT_MODAL,
  SET_APARTMENT_MODAL_REMOVE_TENANT,
  SET_APARTMENT_MODAL_UPDATE_APARTMENT_OWNER,
  SET_APARTMENT_MODAL_UPDATE_TENANT,
  SET_APARTMENT_MODAL_UPDATE_LEASES,
  SET_ANNOUNCEMENT_STATE,
  SET_CONTACT_MODAL_STATE,
  SET_CONFIRMATION_MODAL_STATE,
  SET_LEASE_MODAL_STATE,
}
